import type { IconNode } from '../types';

/**
 * @name globe-ban
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMjJhMTQuNDggMTQuNDggMCAwMS00LjAwOC0xMEM3Ljk5MyA5LjEzNiA5IDUuMjU4IDExIDIuMDVBMTAgMTAgMCAwMDEyIDIyIiAvPgogIDxwYXRoIGQ9Im0xNS4xNzIgMy4xNzIgNS42NTYgNS42NTYiIC8+CiAgPHBhdGggZD0iTTE1Ljg2IDE0YTE0LjUgMTQuNSAwIDAxLTMuODU5IDggMTAgMTAgMCAwMDkuOTQ5LTkiIC8+CiAgPHBhdGggZD0iTTIgMTJoMTAuNSIgLz4KICA8Y2lyY2xlIGN4PSIxOCIgY3k9IjYiIHI9IjQiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/globe-ban
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const GlobeBan: IconNode = [
  ['path', { d: 'M12 22a14.48 14.48 0 01-4.008-10C7.993 9.136 9 5.258 11 2.05A10 10 0 0012 22' }],
  ['path', { d: 'm15.172 3.172 5.656 5.656' }],
  ['path', { d: 'M15.86 14a14.5 14.5 0 01-3.859 8 10 10 0 009.949-9' }],
  ['path', { d: 'M2 12h10.5' }],
  ['circle', { cx: '18', cy: '6', r: '4' }],
];

export default GlobeBan;
